// extracted by mini-css-extract-plugin
export default {"Container":"PricingTable_Container__Xk6Vn","ExtrasTitle":"PricingTable_ExtrasTitle__KJXIo"};